// extracted by mini-css-extract-plugin
export default {"main":"images_main__HZiuD","mImg":"images_mImg__UzezX","discount":"images_discount__rpDbF","images":"images_images__d+fj6"};